var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlgorithm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_175_420)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_175_420)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_175_420)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_175_420",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.272 0.727051H0.726562V47.2725H47.272V0.727051Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_175_420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1059 0.727051H5.89272C3.03952 0.727051 0.726562 3.04001 0.726562 5.8932V42.1064C0.726562 44.9595 3.03952 47.2725 5.89272 47.2725H42.1059C44.959 47.2725 47.272 44.9595 47.272 42.1064V5.8932C47.272 3.04001 44.959 0.727051 42.1059 0.727051Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.603 35.1676L17.2061 24.0044H10.418L13.0211 35.1676C13.2113 35.9986 14.3927 35.9986 14.593 35.1676H14.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8199 12.8308L17.2168 23.9941H24.0049L21.4018 12.8308C21.2116 11.9998 20.0302 11.9998 19.8299 12.8308H19.8199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1792 35.1676L30.7822 24.0044H23.9941L26.5972 35.1676C26.7875 35.9986 27.9688 35.9986 28.1691 35.1676H28.1792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3863 12.8308L30.7832 23.9941H37.5713L34.9682 12.8308C34.778 11.9998 33.5966 11.9998 33.3963 12.8308H33.3863Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175_420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_175_420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_175_420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 46.5455,
    fill: "white",
    transform: "translate(0 0.727051)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgorithm);
export default __webpack_public_path__ + "static/media/algorithm.69fd2c22467ca98d826838425c04afa4.svg";
export { ForwardRef as ReactComponent };